import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';

@Component({
  selector: 'app-covid-faqs',
  standalone: true,
  imports: [FooterComponent, StaticSearchComponent, CommonHeaderComponent],
  templateUrl: './covid-faqs.component.html',
  styleUrl: './covid-faqs.component.scss',
})
export class CovidFaqsComponent {
  constructor(private titleService: Title, private metaService: Meta) {
    this.titleService.setTitle('COVID-19 Travel Insurance FAQs | World2Cover');
    this.metaService.updateTag({
      name: 'description',
      content: `Find answers to COVID-19 travel insurance FAQs with World2Cover. Learn about cover for overseas medical costs, quarantine, cancellations and emergencies.`,
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'COVID-19 Travel Insurance FAQs | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'Find answers to COVID-19 travel insurance FAQs with World2Cover. Learn about cover for overseas medical costs, quarantine, cancellations and emergencies.',
    });
  }
}
